import { render, staticRenderFns } from "./passwdForm.vue?vue&type=template&id=4656b34a"
import script from "./passwdForm.vue?vue&type=script&lang=js"
export * from "./passwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports